import React, { useEffect, useState } from 'react'
import firstStepsApi from '../../utils/firstStepsApi'
import KitList from './KitList'

const KitPartners = () => {
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        const fetch = async () => {
            setLoading(true)
            try {
                const partners = await firstStepsApi.getContentKitPartners()
                setItems(partners)
            }
            catch (err) {
                setError(err)
            }
            finally {
                setLoading(false)
            }
        }
        fetch()
    }, [])

    return (
        <KitList
            title="רשימת החברות המשתפות פעולה עם רשת מוצצים וצעדים ראשונים"
            items={items}
            loading={loading}
            error={error}
        />
    )
}

export default KitPartners
